import React from 'react';
import { Server, Lock, Search, AlertCircle } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Ports feature
 * Displays information about the Ports feature and its benefits
 */
export const PortsFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Port Security Management"
      description="Discover, monitor, and secure all network ports across your infrastructure with comprehensive visibility and vulnerability detection."
      icon={<Server className="h-8 w-8 text-blue-600" />}
      featureName="ports"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Search className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Port Discovery</h3>
          </div>
          <p className="text-gray-400">
            Automatically discover and inventory all open ports across your network infrastructure for complete visibility.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertCircle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Vulnerability Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify vulnerable and unnecessarily exposed ports that could lead to security breaches or unauthorized access.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Lock className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Recommendations</h3>
          </div>
          <p className="text-gray-400">
            Receive actionable recommendations to secure open ports and minimize your attack surface with best practices.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Server className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Service Mapping</h3>
          </div>
          <p className="text-gray-400">
            Map ports to running services and applications for better understanding of your network infrastructure.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
